import initTHEOplayerMux from '@mux/mux-data-theoplayer';
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      channelSettings: (state) => state.channel.settings,
    }),
    analyticsKey() {
      return this.channelSettings?.['mux-qos-analytics']?.['mux-qos-analytics-key'] || null;
    },
    hasAnalyticsKey() {
      return !!this.analyticsKey;
    },
  },
  methods: {
    setupMuxTheoAnalytics(player, analyticsOptions) {
      if (!analyticsOptions || !player || !this.hasAnalyticsKey) {
        return;
      }

      const viewerUserId = this.user?.id || '';
      const playerInitTime = initTHEOplayerMux.utils.now();

      const muxData = {
        env_key: this.analyticsKey,
        viewer_user_id: viewerUserId,
        player_name: 'THEO Web Player',
        player_init_time: playerInitTime,
        video_id: analyticsOptions.uniqueId,
        // eslint-disable-next-line max-len
        video_title: `${analyticsOptions.uniqueId} | ${analyticsOptions.videoTitle} | ${analyticsOptions.streamType}`,
        video_content_type: analyticsOptions.videoContentType || 'clip',
        video_stream_type: analyticsOptions.streamType,
      };

      initTHEOplayerMux(
          player,
          {debug: false, data: muxData},
          window.THEOplayer,
      );
    },
  },
};
